import { render } from "./QualitySafety.vue?vue&type=template&id=4e4335b5&scoped=true"
import script from "./QualitySafety.vue?vue&type=script&lang=js"
export * from "./QualitySafety.vue?vue&type=script&lang=js"

import "./QualitySafety.vue?vue&type=style&index=0&id=4e4335b5&scoped=true&lang=css"

import exportComponent from "C:\\bluespeed\\bluespeed\\frontend\\bluespeed\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e4335b5"]])

export default __exports__